<template>
    <div class="art-cont">
                    <h1 class="fs28 lh38">澳獲辦寶船國際茶文化節</h1>
                    <div class="title-info">2022-04-27</div>
                    <div class="main-content">
                        <p>
	<img src="/core/extend/kindeditor/attached/image/20220605/20220605033537_46481.jpg" alt="" ondragstart="return false">
</p>
<p>
	</p><div class="attachment" align="center" style="margin:0px;padding:0px;color:#373535;font-family:">
		<p style="margin-top:30px;margin-bottom:30px;padding:0px;text-indent:2em;line-height:27px;">
			“寶船獎”評審委員會成員合照
		</p>
	</div>
	<div id="ozoom" class="content" style="margin:20px 0px 0px;padding:0px;color:#373535;font-family:">
		<founder-content style="margin:0px;padding:0px;">
		<p style="margin-top:20px;margin-bottom:10px;padding:0px;line-height:27px;font-size:16px;">
			澳獲辦寶船國際茶文化節
		</p>
		<p style="margin-top:30px;margin-bottom:30px;padding:0px;text-indent:2em;line-height:27px;">
			【本報消息】二○二○迪拜世博會中華文化館、中國國家地理·國家茶地理主辦，中國茶葉博物館、中華文化促進會、中國農業國際合作促進會聯合主辦，首屆寶船國際茶文化節（內地部分）本月廿三日線上舉行，依托世博會平台及其國際影響力，寶船國際茶文化節旨在團結政府、協會、企業以及高校等各界力量，共同服務“中國茶葉的新國際化戰略”。迪拜、北京、杭州、深圳、成都、澳門等多地人員線上參與。大會宣佈，第二屆寶船國際茶文化節舉辦城市為澳門。
		</p>
		<p style="margin-top:30px;margin-bottom:30px;padding:0px;text-indent:2em;line-height:27px;">
			首屆寶船國際茶文化節包含“中國茶葉國際分享迪拜宣言”、“簽約儀式”、“寶船獎發佈”、“中國茶葉迪拜世博會國際分享高端學術論壇”等環節。原中國農業科學院茶葉研究所副所長魯成銀作為寶船獎評審委員會主席，宣讀《中國茶葉國際分享迪拜宣言》，借助世博會的機遇，為中國茶產業高質量發展，以及中國茶文化國際傳播助力。
		</p>
		<p style="margin-top:30px;margin-bottom:30px;padding:0px;text-indent:2em;line-height:27px;">
			為賦能中國茶產業可持續發展，進一步助力中國茶葉品牌走出去，寶船國際茶文化節特別設立“寶船獎”，澳門地區共獲三項大獎，包括澳門智慧人文勵政會會長吳在權獲“茶傳播國際特別貢獻獎”，澳門融貫投資科技有限公司獲“茶科技貢獻獎”，澳門國際青年智庫《中華茶藏》項目獲“文化傳承創新獎”。
		</p>
		<p style="margin-top:30px;margin-bottom:30px;padding:0px;text-indent:2em;line-height:27px;">
			澳門與內地茶文化同根同源。在中國近代史上，澳門一直是中國茶葉出口西方的重要港口，澳門與中國茶業發展淵源極深，借助“一國兩制”制度優勢，澳門正好成為中國茶文化、中國茶品牌出海的第一站。
		</p>
</founder-content>
	</div>
<p></p>
                    </div>
                    <div class="art-bott flex flex-wrap-wrap flex-justify-between flex-align-center">
                        <a href="/News/1" class="art-btn btn-hvr" ondragstart="return false">返回</a>
                        
                    </div>
                    <div class="arc-nav">
                        <a href="/NewsDetail/57" ondragstart="return false">上一条 :  湾区青年说丨粤港澳三地青年畅谈湾区故事</a>
                        <a href="/NewsDetail/55" ondragstart="return false">下一条 : 澳优码助力讲好中国故事 澳门企业荣获世博会首届宝船国际茶文化节“茶科技贡献奖”</a>
                    </div>
                </div>
</template>
  
  <script setup>
  import { ref, onMounted, onUnmounted } from 'vue';
  
  const startAnimate = ref(false)


  onMounted(() => {
    startAnimate.value = true
  });
  
  onUnmounted(() => {
    startAnimate.value = false
  });
  </script>
  
  <style scoped>
 .article .art-cont {
    background: #fff;
    width: calc(70% - 80px);
    padding: 50px 40px;
    overflow: hidden;
    border-radius: 8px;
}
.article .art-cont h1 {
    color: #333;
    font-weight: 700;
}
    .article .art-cont h1 {
        font-size: 26px;
    }

    .article .art-cont .title-info {
        font-size: 14px;
        color: #888;
        font-family: OPPOSans-H;
        padding-left: 30px;
        height: 20px;
        line-height: 22px;
        background: url(@/assets/images/news-time.png) no-repeat left center;
        margin: 30px 0;
    }

    .article .art-bott {
        margin-top: 50px;
        display: flex;
        justify-content: space-between;
        padding-bottom: 30px;
        margin-bottom: 30px;
        border-bottom: 1px solid #f0f0f0;
        align-items: center;
    }
    .article .art-bott .art-btn {
        background: #ea5413;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 110px;
        height: 42px;
        font-weight: 700;
        color: #fff;
        border-radius: 30px;
        transition: all .4s ease;
        font-size: 16px;
    }
    .btn-hvr:hover {
        border-color: transparent;
        box-shadow: 0 0 0 .2rem rgba(234, 84, 19, .5);
    }
    .article .arc-nav a {
        position: relative;
        display: block;
        font-size: 14px;
        color: #666;
        padding-left: 15px;
        transition: all .4s ease;
        font-weight: 700;
    }

  </style>